import { z } from "zod";
import type { ApiMoney } from "./tasks";

/** GET /v1/provider/tasks/mine — hizmet verenin kabul ettiği/yürüttüğü işler (web paneli, K-126) */
export const ProviderJobsQuery = z.object({
  scope: z.enum(["upcoming", "past"]).default("upcoming"),
  locale: z
    .string()
    .regex(/^[a-z]{2}$/)
    .optional(),
});

export interface ProviderJobItem {
  id: string;
  status: string;
  service: { code: string; name: string };
  /** müşterinin adı ve soyadının baş harfi */
  customerName: string | null;
  scheduledStart: string | null;
  scheduledMinutes: number | null;
  locality: string | null;
  hourlyRate: ApiMoney | null;
}

export interface ProviderJobsResponse {
  jobs: ProviderJobItem[];
}

/** GET /v1/provider/earnings — aktarımlar (payouts); tutarlar hizmet verenin alacağı */
export interface ProviderEarningsResponse {
  currency: string;
  paid: ApiMoney;
  /** henüz ödenmemiş (bekleyen + yolda) */
  pending: ApiMoney;
  payouts: {
    id: string;
    status: "pending" | "in_transit" | "paid" | "failed" | "cancelled";
    amount: ApiMoney;
    taskId: string | null;
    serviceName: string | null;
    scheduledFor: string | null;
    paidAt: string | null;
    createdAt: string;
  }[];
}

/** GET /v1/provider/members/:memberId/availability — haftalık saatler ve izinler (takvim sayfası) */
export interface MemberAvailabilityResponse {
  /** weekday 0 = Pazartesi; saat "HH:MM" */
  rules: { weekday: number; start: string; end: string }[];
  /** isAvailable=false izin/kapalı, true ek müsaitlik; yalnızca bitmemiş olanlar */
  timeOff: { id: string; startsAt: string; endsAt: string; isAvailable: boolean }[];
}
